(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee-announcement"] && !window.DesignMode) return;
  try {
    
let logoScrollers = new WeakMap();

function loadNewContentViaAjax() {
  setTimeout(() => {
    const ajaxContainer = document.querySelector(".ajax-overlay");
    if (ajaxContainer) {
      initiateLogoScroller(ajaxContainer);
    }
  }, 1000);
}

function initiateLogoScroller(container = document) {
  const rows = container.querySelectorAll(".marquee-content");

  rows.forEach((row) => {
    // Kill any existing animation for this row
    if (logoScrollers.has(row)) {
      logoScrollers.get(row).kill();
      logoScrollers.delete(row);
    }

    const rowItems = Array.from(row.children);
    let rowWidth = row.scrollWidth;
    const containerWidth = window.innerWidth;

    // Prevent duplicate cloning
    if (!row.dataset.cloned) {
      let totalWidth = rowWidth;
      let cloneLimit = 50; // prevent runaway loop

      while (totalWidth < containerWidth * 2 && cloneLimit-- > 0) {
        rowItems.forEach((item) => {
          const itemWidth = item.offsetWidth || 100; // fallback to prevent 0
          const clone = item.cloneNode(true);
          row.appendChild(clone);
          totalWidth += itemWidth;
        });
      }

      rowWidth = row.scrollWidth; // Update rowWidth after cloning
      row.dataset.cloned = "true";
    }

    // Reset row position to start
    gsap.set(row, { x: 0 });

    // Calculate speed dynamically
    let baseSpeed = 20;
    let duration = (rowWidth / containerWidth) * baseSpeed;
    //console.log(duration);
    if (window.innerWidth < 768) {
      duration *= 0.25;
    }
    //console.log(duration);
    const tl = gsap.timeline({ repeat: -1, ease: "none" });
    tl.to(row, {
      x: `-${rowWidth / 2}px`,
      duration,
      ease: "none",
      onComplete: () => gsap.set(row, { x: 0 }),
    });

    logoScrollers.set(row, tl);

    // Pause/resume on hover/touch
    row.addEventListener("mouseenter", () => tl.pause());
    row.addEventListener("mouseleave", () => tl.resume());
    row.addEventListener("touchstart", () => tl.pause());
    row.addEventListener("touchend", () => tl.resume());
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initiateLogoScroller(document);
});

  } catch(e) { console.error(e); }
})();
})();
